const messages = {
  "999": "One or more values have not been provided or are not correct. Check fields marked with red and try the request again",
  "000": "We have encountered a problem while accessing the server, please try after some time",
  "002": "All mandatory values have not been provided; backend mandatory parameter check failed",
  "003": "The request cannot be performed in the current state; Check the details and retry the request",
  "004": "The entity does not exist; Check the details and retry the request",
  "006": "The code that you have provided does not exist or has expired. Check your email and provide the correct code",
  "007": "The password does not does not match the password rules. Your password must be at least 6 characters long with at least one numeric, one lower case and upper case character",
  "008": "User with the same emailId already exists, use a different emailId and try again",
  "011": "You must add units to your proposal. All units are either removed or there are no units in the proposal.",
  "013": "Exaspaces does not support more than one account in the same browser. Log out of all sessions and login again.",
  "502": "Check your username and password. If you still cannot log in, you can reset your password and try again",
  "503": "You have no password. You can reset your password, using the forgot password, and try again",
  "504": "You are not authorized to perform this action, contact your administrator to get the required authorization",

  "015": "Business addon not activated, you must activate the addon before you can proceed",
  "016": "Your subscription limit has been reached, additional units needs to be purchased before you can proceed",

  "otp": "A one-time passcode has been sent to your emailid, enter the code to procced with the password update",
  "password": "Your password has been reset successfully. You must use the new password the next time you login",
 
  "NOTACTIVE": "User a/c is not authorized to access exaspaces administration",

  // success message for the respective entities
  "user": "Your profile has been saved successfully",
  "personalization": "Your personalization settings has been saved successfully",
  "approve": "Business client has been approved for access to Exaspaces platform",
  "reject": "Business client has not been approved for access to Exaspaces platform",
  "suspend": "Exaspaces plaform access has been temporarily suspended",
  "resume": "Exaspaces plaform access has been resumed",

  "addonactivate": "Business addon has been activated successfully",
  "addondeactivate": "Business addon has been deactivated successfully",
  "addonapprove": "Business addon has been approved successfully",
  "addonreject": "Business addon has been rejected successfully",

  "template": "Business template has been saved successfully",
  "saveastemplate": "Business template saved as a system template",
  "activatetemplate": "Business template has been activated successfully",
  "deactivatetemplate": "Business template has been deactivated successfully",
  "removetemplate": "Business template has been removed successfully",
  "deletetemplate": "Business template has been deleted successfully",

  "logout": "Your session has ended and you have been logged out",
}

export {
  messages
}